import { Box, Fade, Modal, useTheme } from '@mui/material';
import { ModalOwnProps } from '@mui/material/Modal/Modal';
import { FC, useCallback } from 'react';

import { VpSystemThemeProvider } from '@vp/common/ui/component/VpSystemThemeProvider';
import { ProfileVideoModel } from '@vp/profile/core/model/ProfileVideoModel';
import { VideoViewerContent } from '@vp/profile/ui/gallery/video/VideoViewerContent';

export interface ProfileVideoViewerProps {
  open: boolean;
  video: ProfileVideoModel | null;
  close: () => void;
}

export const ProfileVideoViewer: FC<ProfileVideoViewerProps> = ({ video, open, close }) => {
  const { transitions } = useTheme();
  const fadeDuration = transitions.duration.modalFadeDuration;

  const onClose = useCallback<NonNullable<ModalOwnProps['onClose']>>((_, reason) => reason === 'escapeKeyDown' && close?.(), [close]);

  return (
    <Modal open={open} onClose={onClose} aria-modal hideBackdrop>
      <Fade in={open} timeout={fadeDuration} easing="ease-in-out">
        <Box width={1} height={1}>
          <VpSystemThemeProvider>{video && <VideoViewerContent video={video} close={close} />}</VpSystemThemeProvider>
        </Box>
      </Fade>
    </Modal>
  );
};
